module.exports = __webpack_public_path__ + "img/store-title.a6dfa859.jpg";